import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FolderTwoToneSvg from "@ant-design/icons-svg/es/asn/FolderTwoTone";
import AntdIcon from '../components/AntdIcon';
var FolderTwoTone = function FolderTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: FolderTwoToneSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(FolderTwoTone);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'FolderTwoTone';
}
export default RefIcon;